import InsideSalesCommissions from './InsideSalesCommissions';

export default InsideSalesCommissions;
